exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " {\n  border-style: solid;\n  border-color: black;\n  border-radius: 10px;\n}\n\n.footer {\n  margin-top: 50px;\n}\n\n.userListImage{\n  border-radius: 50%\n}\n\n.userListSubtitle{\n  font-size: 12px;\n}\n\nimg:hover {\n  cursor: pointer;\n}\n\n.displayed {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.verticalCentered {\n  margin-top: 40px;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/footer/footer.component.css
// module id = ../../../../../src/app/components/footer/footer.component.css
// module chunks = main